import React, { useState } from "react";
import ReactMarkdown from "react-markdown";
import { Modal } from "../components/Modal";
import { shortcutHelp } from './shortcuts'
import { summaryHelp } from "./summary";
import gfm from 'remark-gfm';
import { HelpPage } from "./help-model";
import { welcomeHelp } from "./welcome";


function HelpPageRender({page, onBack}:{page:HelpPage, onBack:()=>void}){
    return <>
    <a className="btn btn-secondary btn-sm me-2 mb-4" onClick={onBack}><i className="fa fa-chevron-left"></i> Voltar</a> 
    <h4>{page.title}</h4>
    <div className="main-obs">
        <ReactMarkdown remarkPlugins={[gfm]}>
            {page.body}
        </ReactMarkdown>
    </div>
</>
}


function HelpModal(){
    const helpPages = [shortcutHelp, summaryHelp, welcomeHelp];
    const [page, setPage] = useState<HelpPage>(null);

    if(page)
        return <HelpPageRender page={page} onBack={() => setPage(null)} />

    return <>
        <div className="main-obs">
            <ul>
                {helpPages.map(h => <li><a className="link" href="#" onClick={(e) => {e.preventDefault(); setPage(h)}}>{h.title}</a></li>)}
            </ul>
        </div>
    </>
}

export function HelpModalButton(){
    const [show, setShow] = useState(false);

    return <>
        <button className="btn btn-primary me-2 mb-2" onClick={() => setShow(true)}><i className="fa fa-question"></i> Ajuda</button>
        {show && <Modal className="modal-primary" onHide={() => setShow(false)} title={<><i className="fa fa-circle-question me-2"></i> Ajuda</>}><HelpModal /></Modal>}
    </>


}